import { createClient } from "@sanity/client";
import type { QueryParams } from "@sanity/client";

const token = import.meta.env.VITE_SANITY_READ_TOKEN ?? "";

// Shared on the server and the browser
export const client = createClient({
  projectId: "ul6sgfcc",
  dataset: "production",
  useCdn: false, // set to `false` to bypass the edge cache
  apiVersion: "2021-10-21", // use current date (YYYY-MM-DD) to target the latest API version
  perspective: "published",
  // token,
});

// Only defined on the server, passed to the browser via a `loader`

const DEFAULT_PARAMS = {} as QueryParams;

// Utility for fetching data on the server, that can toggle between published and preview drafts
export async function sanityFetch<QueryResponse>({
  previewDrafts,
  query,
  params = DEFAULT_PARAMS,
}: {
  previewDrafts?: boolean;
  query: string;
  params?: QueryParams;
}): Promise<QueryResponse> {
  if (previewDrafts && !token) {
    throw new Error("The `SANITY_API_READ_TOKEN` environment variable is required.");
  }
  return client.fetch<QueryResponse>(
    query,
    params,
    previewDrafts
      ? {
          token,
          perspective: "raw",
        }
      : {}
  );
}
